import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "omni-arrow-change-red",
  "use": "omni-arrow-change-red-usage",
  "viewBox": "0 0 288 288",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:svgjs=\"http://svgjs.com/svgjs\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 288 288\" id=\"omni-arrow-change-red\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"width:7px\" width=\"288\" height=\"288\" viewBox=\"0 0 7 6\"><path fill=\"red\" d=\"M3.5 0L7 6H0z\" class=\"color39b3ae svgShape\" data-name=\"Polygon 127\" /></svg></symbol>"
});
var result = sprite.add(symbol);
export default symbol